<div class="tabs">
  <div (click)="goToCompareList()" class="detail" [class.selectTab]="!showGrid">
    <i class="icon-shield-account-outline"></i> <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.Detail" | translate }}</span>
  </div>
  <div (click)="showGrid = true" class="detail" [class.selectTab]="showGrid">
    <i class="icon-account-clock-outline"></i> <span> {{ "ClientApp.FrontOffice.Review.SecurityReview.Security" | translate }}</span>
  </div>
</div>

<sepidz-review [hasIncludeTime]="true" class="review show" [class.hide]="!showGrid">
  <div review-filters class="filtering">
    <div class="listbox">
      <div class="titleheader" *ngIf="isMultiBranch">
        <div class="title" (click)="setSelectedFilter('Branch')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SecurityReview.Branch" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Branch'"></i>
        </div>
        <div *ngIf="selected === 'Branch'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SecurityReview.Branch' | translate"
            [form]="formGroup"
            name="Branch"
            key="BranchIds"
            apiName="Branch/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('SaleMethod')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SecurityReview.SaleMethod" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'SaleMethod'"></i>
        </div>
        <div *ngIf="selected === 'SaleMethod'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SecurityReview.SaleMethod' | translate"
            [form]="formGroup"
            name="SaleMethod"
            key="SaleMethodIds"
            apiName="SaleMethod/ReadSaleMethodLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('User')">
          <span class="name"> {{ "ClientApp.FrontOffice.Review.SecurityReview.User" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'User'"></i>
        </div>
        <div *ngIf="selected === 'User'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SecurityReview.User' | translate"
            [form]="formGroup"
            textFieldName="DisplayName"
            name="UserList"
            key="UserListIds"
            apiName="Authorization/GetUserList">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('FactorStatus')">
          <span class="name"> {{ "ClientApp.FrontOffice.Review.SecurityReview.FactorStatus" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'FactorStatus'"></i>
        </div>
        <div *ngIf="selected === 'FactorStatus'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SecurityReview.FactorStatus' | translate"
            [form]="formGroup"
            name="InvoiceStatus"
            key="InvoiceStatusIds"
            apiName="Lookup"
            systemName="SALE"
            category="InvoiceStatus">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('FactorOpration')">
          <span class="name"> {{ "ClientApp.FrontOffice.Review.SecurityReview.FactorOpration" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'FactorOpration'"></i>
        </div>
        <div *ngIf="selected === 'FactorOpration'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SecurityReview.FactorOpration' | translate"
            [form]="formGroup"
            name="InvoiceCommand"
            key="InvoiceCommandIds"
            apiName="Lookup"
            systemName="SALE"
            category="InvoiceCommand">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('FactorCallect')">
          <span class="name"> {{ "ClientApp.FrontOffice.Review.SecurityReview.FactorCallect" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'FactorCallect'"></i>
        </div>
        <div *ngIf="selected === 'FactorCallect'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SecurityReview.FactorCallect' | translate"
            [form]="formGroup"
            name="InvoicePayableChange"
            key="InvoicePayableChangeIds"
            apiName="Lookup"
            systemName="SALE"
            category="InvoicePayableChange">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('FactorChange')">
          <span class="name"> {{ "ClientApp.FrontOffice.Review.SecurityReview.InvoiceChanges" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'FactorChange'"></i>
        </div>
        <div *ngIf="selected === 'FactorChange'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SecurityReview.InvoiceChanges' | translate"
            [form]="formGroup"
            name="InvoiceChanges"
            key="InvoiceChangesIds"
            apiName="Lookup"
            systemName="SALE"
            category="InvoiceChanges">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('SMSType')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.SMSType" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'SMSType'"></i>
        </div>
        <div *ngIf="selected === 'SMSType'">
          <sepidz-remote-select-review
            [form]="formGroup"
            key="SMSType"
            name="SMSType"
            [items]="[
              { Id: 1, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.InvoiceLink' | translate },
              { Id: 2, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.PaymentLink' | translate }
            ]">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('PaymentState')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.PaymentState" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'PaymentState'"></i>
        </div>
        <div *ngIf="selected === 'PaymentState'">
          <sepidz-remote-select-review [form]="formGroup" key="PaymentState" name="PaymentState" [items]="paymentStates">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('accountstatus')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.AccountStatus" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'accountstatus'"></i>
        </div>
        <div *ngIf="selected === 'accountstatus'">
          <sepidz-remote-select-review
            [form]="formGroup"
            key="accountstatus"
            name="accountstatus"
            [items]="[
              { Id: 1, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.LinkPayment' | translate },
              { Id: 2, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.Online' | translate }
            ]">
          </sepidz-remote-select-review>
        </div>
      </div>
    </div>
  </div>
  <div review-content class="gridbox">
    <div class="grid-box">
      <div class="cardbody" *ngIf="SecurityReviewInfoColumns && SecurityReviewInfoColumns.length > 0">
        <sepidz-grid-review
          *hasPermission="['RestaurantSale:SecurityReview/GetSecurityReview', 'Same']"
          name="SecurityReviewId"
          [title]="'ClientApp.FrontOffice.Review.SecurityReview.SecurityReviewId' | translate"
          apiName="SecurityReview/GetSecurityReview"
          areaName="RestaurantSale"
          [groupable]="false"
          [columns]="SecurityReviewInfoColumns"
          [unSortableFilterable]="unSortableFilterable"
          (onRowSelected)="onRowSelected($event)"
          [selective]="false"
          [filtering]="true"
          pathPreFix="SALE"
          displayNameColumn="Number"
          key="SecurityReviewIds"
          aggregatesColumnName="TotalDiscount,Tip,Credit,Debit,PayableTotal,TotalTax,TotalService,TotalNet">
        </sepidz-grid-review>
      </div>
      <div class="cardbody detail-grid" *ngIf="InvoiceHistoryColumnInfo && InvoiceHistoryColumnInfo.length > 0">
        <div class="statebox">
          <ssg-button
            class="statebtn"
            [label]="'ClientApp.FrontOffice.Review.SecurityReview.CompareList' | translate"
            (click)="goToCompareList()"></ssg-button>
        </div>
        <kgrid
          class="griddetail"
          label="detail"
          areaName="RestaurantSale"
          apiName="{{ onFilter && onFilter.length > 0 ? apiName : '' }}"
          [isAdd]="false"
          [isEdit]="false"
          [isDelete]="false"
          [groupable]="false"
          [noToolBar]="false"
          pathPreFix="SALE"
          defaultSortKey="Code"
          defaultSortKeyKind="asc"
          (onRowsSelected)="onDetailRowSelected($event)"
          [columns]="InvoiceHistoryColumnInfo"
          [filters]="onFilter"
          [filtering]="false"
          [isMulti]="true">
        </kgrid>
      </div>
    </div>
  </div>
</sepidz-review>
<detail-security-review *ngIf="!showGrid" [IsDelino]="hasWebId"></detail-security-review>
